import React from 'react';
import { View } from 'react-native';
import { CardView, rem } from 'design-system';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import Text from 'design-system/Text';
const QuoteDetailsCard = ({ children, title, style, }) => {
    const styles = useStyles(styleSheet);
    return (<CardView noMarginTop style={style}>
      <View style={styles.headerContainer}>
        <Text Text-16>{title}</Text>
      </View>
      {children}
    </CardView>);
};
const styleSheet = createStyleSheets((colors) => ({
    headerContainer: {
        padding: rem(16),
        borderBottomWidth: rem(1),
        borderBottomColor: colors.background.dark,
    },
}));
export default QuoteDetailsCard;
